import React, { useRef } from 'react';

const ImageModal = ({ imageUrl, onClose, isVideo }) => {
  const videoRef = useRef(null);
  if (!imageUrl) return null;

  return (
    <div className="image-modal-backdrop" onClick={onClose}>
      <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
        {isVideo ? (
          <video ref={videoRef} src={imageUrl} controls style={{ maxWidth: '100%', maxHeight: '70vh' }} autoPlay />
        ) : (
          <img src={imageUrl} alt="Unit" />
        )}
        <button onClick={onClose} className="close-modal-btn">×</button>
      </div>
    </div>
  );
};

export default ImageModal;
